import { IWidget } from 'common/schema/widget/Widget';
import { IWidgetInput } from 'common/schema/widget/input/WidgetInput';

export function getWidgetInputText(widget: IWidget) {
  const input = widget.input!;
  const message = input.help ? { extra: input.help } : {};

  return {
    label: input.label,
    message: message,
    placeholder: input.placeholder
  };
}

export function getMessageText(input: IWidgetInput) {
  return input.help ? { extra: input.help } : {};
}
